import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Hr/reports/ShiftReport/HumanCapitalReportShiftAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalReportShiftActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Hr/reports/ShiftReport/HumanCapitalReportShift")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalReportShift"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalReportShift"
				action="HumanCapitalReportShift"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalReportShiftActivity)
